"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbDynamicTabs = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _value = require("../../skybase-core/utils/value");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NOOP = function NOOP() {};

var SbDynamicTabs = /*#__PURE__*/function (_Component) {
  _inherits(SbDynamicTabs, _Component);

  var _super = _createSuper(SbDynamicTabs);

  function SbDynamicTabs(_props) {
    var _this;

    _classCallCheck(this, SbDynamicTabs);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "tab", function (props) {
      var tabTitle = props.tabTitle,
          tabId = props.tabId,
          className = props.className,
          rest = _objectWithoutProperties(props, ["tabTitle", "tabId", "className"]);

      return /*#__PURE__*/_react.default.createElement("div", _extends({}, rest, {
        className: (0, _classnames.default)(className, 'dynamic-tab-tabs-tab'),
        onClick: function onClick() {
          return _this.handlePanelOnClick(tabId);
        }
      }), tabTitle);
    });

    _defineProperty(_assertThisInitialized(_this), "handlePanelOnClick", function (tabId) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          namespace = _this$props.namespace;
      var activeTabId = _this.state.activeTabId;

      if (activeTabId !== tabId) {
        if (onChange) {
          onChange(tabId, namespace);
        }

        _this.setState({
          activeTabId: tabId
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "processChildren", function () {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          isEnabled = _this$props2.isEnabled,
          namespace = _this$props2.namespace;
      var _this$state = _this.state,
          activeTabId = _this$state.activeTabId,
          tabsIds = _this$state.tabsIds;
      var tabs = [];
      var activeTabChildren = null;

      _react.default.Children.forEach(children, function (child, idx) {
        if (child && child.props) {
          var _child$props = child.props,
              dynamicTabChildren = _child$props.children,
              tabId = _child$props.tabId,
              tabTitle = _child$props.tabTitle,
              className = _child$props.className,
              rest = _objectWithoutProperties(_child$props, ["children", "tabId", "tabTitle", "className"]);

          var isActive = activeTabId === tabId || activeTabId === tabsIds[idx]; // condition to render only first tab when disabled

          if (isEnabled || idx === 0) {
            var _getTabTitle = (0, _utils.getTabTitle)(dynamicTabChildren),
                tabTitleComponent = _getTabTitle.tabTitleComponent,
                restChildren = _getTabTitle.restChildren;

            tabs.push(_this.tab(_objectSpread(_objectSpread({}, rest), {}, {
              tabId: tabId || tabsIds[idx],
              className: (0, _classnames.default)(className, {
                active: isActive
              }),
              tabTitle: tabTitleComponent,
              key: tabId || "".concat(namespace, "-tab-").concat(idx)
            })));

            if (isActive) {
              activeTabChildren = restChildren;
            }
          }
        }
      });

      return {
        tabs: tabs,
        activeTabChildren: activeTabChildren
      };
    });

    var _this$props3 = _this.props,
        selectedTabId = _this$props3.selectedTabId,
        _namespace = _this$props3.namespace,
        _children = _this$props3.children;

    var _tabsIds = (0, _utils.generateTabIds)({
      tabs: _children,
      namespace: _namespace
    });

    var _activeTabId = selectedTabId !== null && selectedTabId !== void 0 ? selectedTabId : _tabsIds[0];

    _this.state = {
      tabsIds: _tabsIds,
      activeTabId: _activeTabId,
      previousTabId: _activeTabId
    };
    return _this;
  }

  _createClass(SbDynamicTabs, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          className = _this$props4.className,
          namespace = _this$props4.namespace,
          id = _this$props4.id,
          style = _this$props4.style;

      var _this$processChildren = this.processChildren(),
          tabs = _this$processChildren.tabs,
          activeTabChildren = _this$processChildren.activeTabChildren;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(className, 'dynamic-tabs'),
        id: id || namespace,
        style: style
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "tab-panels"
      }, tabs), /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-column tab-content"
      }, activeTabChildren));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var activeTabId = prevState.activeTabId,
          previousTabId = prevState.previousTabId,
          tabsIds = prevState.tabsIds;
      var selectedTabId = nextProps.selectedTabId,
          children = nextProps.children,
          namespace = nextProps.namespace;

      if (activeTabId !== selectedTabId || activeTabId !== previousTabId) {
        if (activeTabId !== previousTabId || (0, _value.isNullOrUndefined)(selectedTabId)) {
          // the change was from the state
          return {
            activeTabId: activeTabId,
            previousTabId: activeTabId
          };
        } // the change was from the props


        return {
          previousTabId: selectedTabId,
          activeTabId: selectedTabId,
          tabsIds: children.length !== tabsIds.length ? (0, _utils.generateTabIds)({
            tabs: children,
            namespace: namespace
          }) : tabsIds
        };
      }

      return null;
    }
  }]);

  return SbDynamicTabs;
}(_react.Component);

exports.SbDynamicTabs = SbDynamicTabs;

_defineProperty(SbDynamicTabs, "displayName", 'SbDynamicTabs');

_defineProperty(SbDynamicTabs, "propTypes", {
  onChange: _propTypes.default.func,
  children: _propTypes.default.node.isRequired,
  namespace: _propTypes.default.string,
  selectedTabId: _propTypes.default.string,
  isEnabled: _propTypes.default.bool,
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  style: _propTypes.default.object // eslint-disable-line

});

_defineProperty(SbDynamicTabs, "defaultProps", {
  selectedTabId: null,
  isEnabled: true,
  onChange: NOOP,
  namespace: null,
  className: null,
  id: null,
  style: null
});
//# sourceMappingURL=sb-dynamic-tabs.js.map